import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Group, LicenseV2 } from '../models';

@Injectable()
export class FeatureToggleService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject('apiBaseUrl') private apiBaseUrl: string,
  ) {}

  public getLicenses(): Observable<LicenseV2[]> {
    return this.httpClient.get<LicenseV2[]>(`${this.apiBaseUrl}v2/licenses`);
  }

  public getGroups(): Observable<Group[]> {
    return this.httpClient.get<Group[]>(
      `${this.apiBaseUrl}configurations/license-groups`,
    );
  }
}
